module.exports = {
    indData: () => {
        return [
            {
                "MOTO MES":{
                    "Nombre":"Raider 125",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/raider/Raider.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/raider/Raider360.png')
                },
                "Apache RR 310":{
                    "Nombre":"Apache RR 310",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/apache-rr.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/apache-rr-moto.png')
                },
                "Neo NX 110":{
                    "Nombre":"Neo NX 110",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/neo/neo.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/neo/neo-moto.png')
                },
                "Ntorq 125":{
                    "Nombre":"Ntorq 125",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125-moto.png')
                },
                "Ntorq 125 Racing":{
                    "Nombre":"Ntorq 125 Racing",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125-race.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125-race-moto.png')
                },
                "Ntorq 125 fi":{
                    "Nombre":"Ntorq 125 fi",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125-fi.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/ntorq/ntorq-125-fi-moto.png')
                },
                "Sport 100 KLS":{
                    "Nombre":"Sport 100 KLS",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/sport/sport-100-kls.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/sport/sport-100-kls-moto.png')
                },
                "Stryker":{
                    "Nombre":"Stryker",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/stryker/stryker.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/stryker/stryker-moto.png')
                },
                "Max 125":{
                    "Nombre":"Max 125",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/max/max.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/max/max-moto.png')
                },
                "Raider 125":{
                    "Nombre":"Raider 125",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/raider/Raider.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/raider/Raider360.png')
                },
                "Apache 160 2V":{
                    "Nombre":"Apache 160 2V",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/rtr-160.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/rtr-160-moto.png')
                },
                "Apache 160 4V":{
                    "Nombre":"Apache 160 4V",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/rtr-160-4v.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/rtr-160-4v-moto.png')
                },
                "Apache 180 2V":{
                    "Nombre":"Apache 180 2V",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/rtr-180.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/rtr-180-moto.png')
                },
                "Apache 200 2V":{
                    "Nombre":"Apache 200 2V",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/rtr-200-4v.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/rtr-200-4v-moto.png')
                },
                "Apache 200 fi":{
                    "Nombre":"Apache 200 fi",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/apache/rtr-200-fi.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/apache/rtr-200-fi-moto.png')
                },
                "Motocarro King Basico":{
                    "Nombre":"Motocarro King Basico",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/king/king-moto.png')
                },
                "Motocarro King Carpa Especial":{
                    "Nombre":"Motocarro King Carpa Especial",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/king/King_02.png')
                },
                "Motocarro King Carpa Full":{
                    "Nombre":"Motocarro King Carpa Full",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/king/King_03.png')
                },
                "Sport 100 ELS":{
                    "Nombre":"Sport 100 ELS",
                    "Logo":require('./../UI/general/Sidebar/btns-motos/sport/sport-100-els.svg'),
                    "Foto":require('./../UI/general/Sidebar/btns-motos/sport/sport-100-els-moto.png')
                }
            }
        ]
    }
}